// Container
const DefaultContainer = () => import('@/containers/DefaultContainer')

// Management
const ManageDocusignTemplateList = () => import('@/modules/docusign/views/management/ManageDocusignTemplateList')
const ManageDocusignTemplateSettings = () => import('@/modules/docusign/views/management/ManageDocusignTemplateSettings')
const ManageDocusignUserList = () => import('@/modules/docusign/views/management/ManageDocusignUserList')
const DocusignSettingsPage = () => import('@/modules/docusign/views/management/DocusignSettingsPage')

var routes = [
    {
        path: '/docusign',
        redirect: '/docusign/manage/template/list',
        name: 'Manage Docusign',
        component: DefaultContainer,
        children: [
			{
				path: '/docusign/manage',
                name: 'DocusignSettingsPage',
                component: DocusignSettingsPage,
                meta: {
                    requiresAuth: true,
                    permission: false,
                    tab: 'docusign-template-list'
                },
				children: [
					{
						path: '/docusign/manage/template/list',
						name: 'ManageDocusignTemplateList',
						component: ManageDocusignTemplateList,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'docusign-template-list'
						},
					},
					{
						path: '/docusign/manage/user/list',
						name: 'ManageDocusignUserList',
						component: ManageDocusignUserList,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'docusign-user-list'
						},
					},
				],
			},
			{
				path: '/docusign/manage/template/:docusign_template_id',
				name: 'ManageDocusignTemplateSettings',
				component: ManageDocusignTemplateSettings,
				meta: {
					requiresAuth: true,
					permission: false,
				}
			},

        ]
    },
];

export default routes;
